export const iconFontAwesomeCommunicationEnvelopeCircleCheck = (
	<i className="fa-solid fa-envelope-circle-check"></i>
);
